"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootRecentlyViewedSagas = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var SavePropertiesAction_1 = require("@/pages/saveproperties/actions/SavePropertiesAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var RootMemberPageSaga_1 = require("@/pages/common/sagas/RootMemberPageSaga");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var LoginSaga_1 = require("@/pages/common/sagas/LoginSaga");
var SignupSaga_1 = require("@/pages/common/sagas/SignupSaga");
var FacebookLoginSaga_1 = require("@/pages/search/sagas/FacebookLoginSaga");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var init = function () {
    var PAGE;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                PAGE = 1;
                return [4 /*yield*/, effects_1.call(loadPageToResult, PAGE)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var loadPageToResult = function (page) {
    var _a, properties, totalPage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.put(SavePropertiesAction_1.default.setIsLoading(true))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getRecentlyViewed, page)];
            case 2:
                _a = _b.sent(), properties = _a.properties, totalPage = _a.totalPage;
                return [4 /*yield*/, effects_1.put(SavePropertiesAction_1.default.setResult(properties, page, totalPage))];
            case 3:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SavePropertiesAction_1.default.setIsLoading(false))];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(init)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSetPage = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SavePropertiesAction_1.default.SET_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(loadPageToResult, payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchResultChange = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SavePropertiesAction_1.default.SET_RESULT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.updateSlider)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchFavClick = function () {
    var payload, item, isSuccess, isSuccess;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(SavePropertiesAction_1.default.ON_FAV_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                item = payload;
                if (!item.isSaved) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 3:
                isSuccess = _a.sent();
                if (!isSuccess) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(init)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 11];
            case 6: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(payload))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 8:
                isSuccess = _a.sent();
                if (!isSuccess) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(SavePropertiesAction_1.default.setIsFav(Number(item.referenceId), true))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchEnquireClick = function () {
    var payload, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SavePropertiesAction_1.default.ON_ENQUIRE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchItemClick = function () {
    var payload, item, lang, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(SavePropertiesAction_1.default.ON_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, item.building, item.referenceId, item.type)];
            case 3:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchUserChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.reload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootRecentlyViewedSagas = {
    rootMemberPageSagas: RootMemberPageSaga_1.rootMemberPageSagas,
    facebookLoginSagas: FacebookLoginSaga_1.facebookLoginSagas,
    userLoginSagas: LoginSaga_1.userLoginSagas,
    signupSagas: SignupSaga_1.signupSagas,
    watchInit: watchInit,
    watchSetPage: watchSetPage,
    watchResultChange: watchResultChange,
    watchFavClick: watchFavClick,
    watchEnquireClick: watchEnquireClick,
    watchItemClick: watchItemClick,
    watchUserChanged: watchUserChanged
};
exports.rootRecentlyViewedSagas = rootRecentlyViewedSagas;
